/**
 * @generated SignedSource<<33dc0ec183783eb8acb8e050a98fe0a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SuiteAccessLevels = "MANAGE_AND_READ" | "READ_ONLY" | "%future added value";
export type TeamSuiteUpdateInput = {
  accessLevel: SuiteAccessLevels;
  clientMutationId?: string | null;
  id: string;
};
export type SuitesTeamAccessLevelChangeMutation$variables = {
  input: TeamSuiteUpdateInput;
};
export type SuitesTeamAccessLevelChangeMutation$data = {
  readonly teamSuiteUpdate: {
    readonly teamSuite: {
      readonly accessLevel: SuiteAccessLevels;
    };
  } | null;
};
export type SuitesTeamAccessLevelChangeMutation = {
  response: SuitesTeamAccessLevelChangeMutation$data;
  variables: SuitesTeamAccessLevelChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessLevel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SuitesTeamAccessLevelChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamSuiteUpdatePayload",
        "kind": "LinkedField",
        "name": "teamSuiteUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamSuite",
            "kind": "LinkedField",
            "name": "teamSuite",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SuitesTeamAccessLevelChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamSuiteUpdatePayload",
        "kind": "LinkedField",
        "name": "teamSuiteUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamSuite",
            "kind": "LinkedField",
            "name": "teamSuite",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5ebd6d33a9578167863ded69875593b",
    "id": null,
    "metadata": {},
    "name": "SuitesTeamAccessLevelChangeMutation",
    "operationKind": "mutation",
    "text": "mutation SuitesTeamAccessLevelChangeMutation(\n  $input: TeamSuiteUpdateInput!\n) {\n  teamSuiteUpdate(input: $input) {\n    teamSuite {\n      accessLevel\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0eaa8fc7c9e20cb67e5181a26e1606e5";

export default node;
